import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, PublicAvailability } from "../stores/store_types"

const afterUseQuestionnairePublicAvailabilitiesCreateAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, status: number) => void, failureCallback: () => void) => {
  axios.post(
    "/api/v1/after_use_questionnaire_public_availabilities",
    {
      corporation_id: parameter.corporationId,
      target_month: parameter.targetMonth.toString()
    },
    {
      headers: headers,
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.status)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const afterUseQuestionnairePublicAvailabilityDestroyAPI = (headers: AuthHeaders, id: number, successCallback: (headers: AxiosResponseHeaders, status: number) => void, failureCallback: () => void) => {
  axios.delete(
    `/api/v1/after_use_questionnaire_public_availabilities/${id}`,
    {
      headers: headers,
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.status)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callAfterUseQuestionnairePublicAvailabilityAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, publicAvailability: PublicAvailability) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/after_use_questionnaire_public_availabilities/find",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { afterUseQuestionnairePublicAvailabilitiesCreateAPI, afterUseQuestionnairePublicAvailabilityDestroyAPI, callAfterUseQuestionnairePublicAvailabilityAPI}
